export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";